const wellcome = {
  phrase1: 'Hello',
  phrase2: 'wellcome'
}

export default wellcome;
